export default __webpack_public_path__ + "static/media/demo_2.67a024ab.mp4";